<div *ngIf="tenant$ | async as tenant">{{tenant.name}}</div>